/**
 * Договор-оферта
 * /terms
 */

import { useNavigate } from 'react-router-dom';

export function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F7F7F4] text-[#252A2D] p-4">
      <div className="max-w-2xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="px-3 py-1.5 bg-white border border-[#E1E5E3] hover:bg-white border border-[#E1E5E3] rounded-lg text-sm transition-all mb-6"
        >
          ← Назад
        </button>

        <h1 className="text-2xl font-bold mb-6 text-center">📄 Договор-оферта</h1>

        <div className="bg-white border border-[#E1E5E3] rounded-2xl p-6 space-y-6 text-[#626B73] text-sm leading-relaxed">
          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">1. Общие положения</h2>
            <p>
              Настоящий договор является публичной офертой (предложением) Курулевой Надежды Александровны, 
              ИНН 631224220031, действующей в качестве самозанятого (далее — «Исполнитель»), 
              адресованной любому физическому лицу (далее — «Заказчик»), и содержит все существенные 
              условия оказания образовательных услуг через платформу BESHEK (далее — «Платформа»).
            </p>
            <p className="mt-2">
              Платформа расположена по адресу: <a href="https://beshek.mugstel.ru" className="text-purple-400 hover:underline">beshek.mugstel.ru</a>
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">2. Предмет договора</h2>
            <p>
              2.1. Исполнитель обязуется предоставить Заказчику доступ к образовательным
              материалам и интерактивным сервисам на Платформе (онлайн-курсам, урокам, тестам,
              AI-викторинам и пакетам игр), а Заказчик обязуется оплатить услуги в соответствии
              с выбранным тарифом.
            </p>
            <p className="mt-2">
              2.2. Перечень доступных курсов и пакетов AI-игр, их содержание и стоимость
              указаны на Платформе в разделе «Курсы», на странице «Тарифы», а также в окне
              покупки внутри VK Mini App.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">3. Акцепт оферты</h2>
            <p>
              3.1. Акцептом (принятием) настоящей оферты является оплата выбранного курса или тарифа.
            </p>
            <p className="mt-2">
              3.2. Совершая оплату, Заказчик подтверждает, что ознакомился с условиями настоящей 
              оферты, политикой возврата и согласен с ними.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">4. Стоимость и порядок оплаты</h2>
            <p>
              4.1. Стоимость услуг указана на Платформе в российских рублях.
            </p>
            <p className="mt-2">
              4.2. На веб-версии и в Telegram оплата производится онлайн через платёжный
              сервис ЮKassa с использованием банковских карт, СБП или электронных кошельков,
              либо через Telegram Stars.
            </p>
            <p className="mt-2">
              4.3. Доступ к оплаченным материалам предоставляется автоматически после
              подтверждения платежа.
            </p>
            <p className="mt-2">
              4.4. Для пользователей VK Mini App (приложение в социальной сети ВКонтакте)
              оплата пакетов AI-игр производится исключительно через сервис VK Голоса
              в соответствии с правилами и тарифами ВКонтакте. Стоимость пакетов указана
              в голосах ВКонтакте; ВКонтакте показывает приблизительную стоимость в рублях
              в окне подтверждения покупки. Иные платёжные системы (включая ЮKassa)
              в VK Mini App не используются.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">5. Права и обязанности сторон</h2>
            <p>
              5.1. Исполнитель обязуется:
            </p>
            <ul className="list-disc list-inside mt-1 space-y-1">
              <li>Предоставить доступ к оплаченным материалам</li>
              <li>Обеспечить техническую доступность Платформы</li>
              <li>Выдать сертификат при успешном прохождении курса</li>
            </ul>
            <p className="mt-3">
              5.2. Заказчик обязуется:
            </p>
            <ul className="list-disc list-inside mt-1 space-y-1">
              <li>Оплатить услуги в соответствии с выбранным тарифом</li>
              <li>Не передавать доступ к своему аккаунту третьим лицам</li>
              <li>Не копировать и не распространять материалы курсов</li>
            </ul>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">6. Интеллектуальная собственность</h2>
            <p>
              6.1. Все материалы курсов (тексты, изображения, видео, тесты) являются 
              интеллектуальной собственностью Исполнителя.
            </p>
            <p className="mt-2">
              6.2. Заказчик получает право использовать материалы исключительно для 
              личного обучения.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">7. Возврат средств</h2>
            <p>
              7.1. Возврат денежных средств за приобретённые цифровые товары (курсы, уроки)
              не производится, так как доступ предоставляется мгновенно после оплаты.
            </p>
            <p className="mt-2">
              7.2. Подробные условия указаны в <a href="/refund" className="text-purple-400 hover:underline">Политике возврата</a>.
            </p>
            <p className="mt-2">
              7.3. Возврат покупок, совершённых через VK Голоса, осуществляется в соответствии
              с правилами ВКонтакте. ВКонтакте автоматически возвращает голоса на счёт
              пользователя, если Платформа не подтвердила передачу товара в течение
              установленного ВКонтакте срока. Спорные ситуации по платежам в VK Mini App
              разрешаются через службу поддержки ВКонтакте и Исполнителя.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">8. Ответственность</h2>
            <p>
              8.1. Исполнитель не несёт ответственности за невозможность использования 
              Платформы по причинам, не зависящим от Исполнителя (проблемы с интернетом, 
              устройством Заказчика и т.д.).
            </p>
            <p className="mt-2">
              8.2. Исполнитель вправе приостановить доступ Заказчика при нарушении 
              условий настоящего договора.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">9. Прочие условия</h2>
            <p>
              9.1. Настоящая оферта вступает в силу с момента её размещения на Платформе.
            </p>
            <p className="mt-2">
              9.2. Исполнитель вправе вносить изменения в оферту. Изменения вступают в силу 
              с момента публикации.
            </p>
            <p className="mt-2">
              9.3. Споры разрешаются путём переговоров, а при недостижении согласия — 
              в соответствии с законодательством РФ.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">10. Реквизиты Исполнителя</h2>
            <p>
              Курулева Надежда Александровна<br />
              ИНН: 631224220031<br />
              Статус: Самозанятый (плательщик НПД)<br />
              Email: qrulev@yandex.ru
            </p>
          </section>

          <p className="text-purple-400 text-xs mt-6">
            Дата публикации: {new Date().toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
}